import React from 'react';
import parse from 'html-react-parser';
import { graphql, useStaticQuery } from 'gatsby';
// import { BodyImage, ButtonModal } from '@shared/components';
import { createAssetLink } from './assets';

const cdnUrl = process.env.GATSBY_CDN_URL
  ? process.env.GATSBY_CDN_URL
  : 'https://cdn.lanl.gov';

export const getSrcID = (src) =>
  typeof src === 'string' && trimParams(src).split('/').pop().split('.')[0];

export const trimParams = (src) =>
  typeof src === 'string' && (/\?/.test(src) ? src.split('?')[0] : src);

export const isAsset = (src) =>
  src && typeof src === 'string' && src.split('/').slice(-2)[0] === 'assets';

export const isUrl = (url) => url && url !== null && url !== '#';

export const UseFiles = (id) => {
  const {
    directus_system: { files },
  } = useStaticQuery(graphql`
    query {
      directus_system {
        files(
          filter: {
            _and: [
              {
                _or: [
                  { type: { _contains: "jpg" } }
                  { type: { _contains: "jpeg" } }
                  { type: { _contains: "png" } }
                  { type: { _contains: "gif" } }
                  { type: { _contains: "pdf" } }
                  { type: { _contains: "epub" } }
                  { type: { _contains: "webp" } }
                  { type: { _contains: "svg" } }
                ]
              }
            ]
          }
          limit: -1
        ) {
          id
          filename_disk
          filename_download
          type
          width
          height
          title
        }
      }
    }
  `);
  return files.find((fid) => fid.id === id);
};

export const createBodyImage = (id, files = {}) => {
  const file = UseFiles(id);
  // if (typeof file === 'object') {
  //   return (
  //     <BodyImage
  //       imgSrc={file.filename_disk ?? ''}
  //       alt={file.title ?? ''}
  //       width={`${file.width}` ?? ''}
  //       height={`${file.height}` ?? ''}
  //     />
  //   );
  // }
  return;
};

export const replaceElements = (body) =>
  parse(body, {
    replace: (domNode) => {
      if (domNode.attribs && domNode.name === 'img') {
        const srcID = trimParams(getSrcID(domNode.attribs.src));
        return createBodyImage(srcID);
      }
      if (
        domNode.attribs &&
        domNode.name === 'a' &&
        isAsset(domNode.attribs.href)
      ) {
        console.log('***** this is a link: domNode.attribs.href *****');
        domNode.attribs.href = createAssetLink(
          UseFiles(trimParams(getSrcID(domNode.attribs.href))),
        );
        return domNode;
      }
      if (
        domNode.attribs &&
        domNode.attribs.class === 'video-modal' &&
        domNode.name === 'p'
      ) {
        const videoMeta = domNode?.children[0]?.attribs ?? {
          title: '',
          src: '',
        };
        // return <ButtonModal video={videoMeta} />;
      }
    },
  });
